import { render, staticRenderFns } from "./Swift.vue?vue&type=template&id=580f6d9e&"
import script from "./Swift.vue?vue&type=script&lang=ts&"
export * from "./Swift.vue?vue&type=script&lang=ts&"
import style0 from "./Swift.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports